export default "__VITE_ASSET__DM72kniz__"